"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLANS = void 0;
__exportStar(require("./model"), exports);
exports.PLANS = {
    MONTH: { name: "month", value: 199, paypalId: "P-5XG25793V1973205XMC2H3SI" },
    YEAR: { name: "year", value: 2250, paypalId: "P-3CX83272EH159892GMC2H4DA" },
};
